import React from 'react'
import PropTypes from 'prop-types'

import theme from 'theme_'

export default function GridIcon({
  color = theme.colors.beachGrey,
  exporting = false,
}) {
  return (
    <svg
      width="30"
      height="30"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_16640_382179"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_16640_382179)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.4199 10.2837L13.7864 8.32992V7.05941H15.6963V8.14885C15.6963 8.36477 15.8658 8.53977 16.0749 8.53977C16.2841 8.53977 16.4535 8.36476 16.4535 8.14885V7.05941H17.246C17.4206 7.05941 17.5718 6.93668 17.6136 6.76166C17.6554 6.58666 17.5754 6.40559 17.4214 6.32226L12.4399 3.64404C12.3864 3.61525 12.3262 3.6001 12.2653 3.6001H12.1472C12.0885 3.6001 12.0305 3.61449 11.9777 3.64177L6.80839 6.31921C6.65137 6.40027 6.56993 6.5821 6.60954 6.75861C6.6499 6.93514 6.80251 7.05939 6.97787 7.05939H7.77032V8.14883C7.77032 8.36475 7.93981 8.53975 8.14892 8.53975C8.35803 8.53975 8.52753 8.36474 8.52753 8.14883V7.05939H10.4367V8.40187L6.80844 10.2815C6.65142 10.3626 6.56998 10.5444 6.6096 10.7209C6.64995 10.8967 6.80256 11.0217 6.97793 11.0217H7.77037V12.1664C7.77037 12.3816 7.93987 12.5573 8.14898 12.5573C8.35809 12.5573 8.52758 12.3823 8.52758 12.1664V11.0217H10.2093L6.75123 19.8629C6.68739 20.0258 6.73655 20.2115 6.87156 20.319C6.9398 20.3728 7.02124 20.4001 7.10269 20.4001C7.18267 20.4001 7.26191 20.3743 7.32941 20.3221L12.1127 16.6272L16.8959 20.3221C16.9627 20.3743 17.0427 20.4001 17.1227 20.4001H17.1241C17.3325 20.4001 17.5027 20.2251 17.5027 20.0092C17.5027 19.9471 17.4888 19.888 17.4631 19.8357L14.0146 11.021H15.6963V12.1657C15.6963 12.3809 15.8658 12.5566 16.0749 12.5566C16.2841 12.5566 16.4535 12.3816 16.4535 12.1657V11.021H17.246C17.4206 11.021 17.5718 10.8982 17.6136 10.7232C17.6539 10.5482 17.5747 10.3672 17.4199 10.2838L17.4199 10.2837ZM15.7007 10.2399H13.7865V9.21103L15.7007 10.2399ZM12.2046 8.35943L11.1935 8.88369V10.239H13.0308V8.80339L12.2046 8.35943ZM10.2117 13.1006L10.9249 11.277L11.5471 11.8566L10.2117 13.1006ZM13.5252 13.6983L12.1121 12.3823L10.6988 13.699L13.5252 13.6983ZM13.6279 14.48L12.112 15.6505L10.5961 14.48H13.6279ZM13.2985 11.2769L12.6763 11.8564L14.0117 13.1004L13.2985 11.2769ZM12.1113 11.3308L11.7789 11.0209H12.4437L12.1113 11.3308ZM13.7865 5.24938V6.27821H15.7001L13.7865 5.24938ZM12.2044 4.39778L13.0306 4.84174V6.2774H11.1934V4.92128L12.2044 4.39778ZM10.4362 5.31379L8.57543 6.27823H10.4362V5.31379ZM11.1935 7.05923H13.0308V7.9229L12.4409 7.60547C12.3873 7.57668 12.3271 7.56153 12.2662 7.56153H12.1481C12.0894 7.56153 12.0314 7.57592 11.9786 7.60319L11.1935 8.01004L11.1928 7.05925L11.1935 7.05923ZM10.4371 10.2397V9.27529L8.57558 10.2397H10.4371ZM7.95994 18.8583L9.59324 14.6816L11.4804 16.1392L7.95994 18.8583ZM14.6304 14.6815L12.7432 16.1391L16.2636 18.8581L14.6304 14.6815Z"
          fill={color}
        />
      </g>
      <path
        d="M 13.543 7.371 L 13.896 7.017 L 13.543 7.371 C 13.923 7.751 14.539 7.751 14.919 7.371 C 14.919 7.371 14.919 7.371 14.92 7.371 L 16.389 5.908 L 16.389 10.01 C 16.389 10.547 16.826 10.985 17.364 10.985 C 17.901 10.985 18.339 10.547 18.339 10.01 L 18.339 5.911 L 19.803 7.376 C 20.184 7.756 20.804 7.756 21.185 7.376 C 21.565 6.995 21.565 6.379 21.185 5.999 L 18.055 2.868 C 17.674 2.488 17.059 2.488 16.678 2.868 C 16.678 2.868 16.678 2.868 16.678 2.868 L 13.543 5.993 L 13.543 5.994 C 13.162 6.374 13.162 6.99 13.543 7.371 Z"
        fill="#23C514"
        stroke="#F4FCF3"
        visibility={exporting ? 'visible' : 'hidden'}
      />
    </svg>
  )
}

GridIcon.propTypes = {
  color: PropTypes.string,
  exporting: PropTypes.bool,
}
